require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./calendrier-acadmique-2-7.json") })
        }
      }, "path---calendrier-acadmique-2-7");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---calendrier-acadmique-2-7!./.cache/json/calendrier-acadmique-2-7.json
// module id = 355
// module chunks = 231608221292675